// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "855957c6e521";
export const BUILD_VERSION_NUMBER = 44;
